import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = { class: "tx-pagehead" }
const _hoisted_3 = { class: "tx-eyebrow tx-mono" }
const _hoisted_4 = { class: "tx-detail" }
const _hoisted_5 = { class: "tx-detail__main" }
const _hoisted_6 = { class: "tx-msg tx-msg--me" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "tx-h2" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "tx-attach"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["onSubmit"]
const _hoisted_13 = ["placeholder", "aria-label"]
const _hoisted_14 = { class: "tx-composer__bar" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 1,
  class: "tx-card tx-rate"
}
const _hoisted_17 = {
  class: "tx-stars",
  role: "radiogroup"
}
const _hoisted_18 = ["aria-checked", "onClick"]
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 2,
  class: "tx-muted"
}
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { class: "tx-detail__side tx-card" }
const _hoisted_24 = { class: "tx-meta" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("a", {
      href: $setup.link('tickets'),
      "data-nav": "",
      class: "tx-backlink"
    }, [
      _createVNode($setup["Icon"], {
        name: "back",
        size: "16"
      }),
      _createTextVNode(_toDisplayString($setup.state.t("tickets.title")), 1 /* TEXT */)
    ], 8 /* PROPS */, _hoisted_1),
    _createVNode($setup["Loader"], {
      loading: $setup.loading,
      error: $setup.error,
      onRetry: $setup.load
    }, {
      default: _withCtx(() => [
        ($setup.t)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("p", _hoisted_3, "#" + _toDisplayString($setup.t.name), 1 /* TEXT */),
                  _createElementVNode("h1", null, _toDisplayString($setup.t.subject), 1 /* TEXT */)
                ]),
                _createVNode($setup["Badge"], {
                  status: $setup.t.overdue ? 'Overdue' : $setup.t.status_category,
                  label: $setup.t.status
                }, null, 8 /* PROPS */, ["status", "label"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("article", _hoisted_6, [
                    _createElementVNode("header", null, [
                      _createElementVNode("strong", null, _toDisplayString($setup.t.is_mine ? $setup.state.t("tickets.you") : ""), 1 /* TEXT */),
                      _createElementVNode("small", null, _toDisplayString($setup.fmtDate($setup.t.opened_on, true)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", {
                      class: "tx-prose",
                      innerHTML: $setup.t.description
                    }, null, 8 /* PROPS */, _hoisted_7)
                  ]),
                  _createElementVNode("h2", _hoisted_8, _toDisplayString($setup.state.t("tickets.timeline")), 1 /* TEXT */),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.t.timeline, (m) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: m.id,
                      class: _normalizeClass(["tx-msg", m.from_customer ? 'tx-msg--me' : 'tx-msg--them'])
                    }, [
                      _createElementVNode("header", null, [
                        _createElementVNode("strong", null, _toDisplayString(m.is_me ? $setup.state.t("tickets.you") : m.author), 1 /* TEXT */),
                        _createElementVNode("small", null, _toDisplayString($setup.fmtDate(m.created, true)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", {
                        class: "tx-prose",
                        innerHTML: m.content
                      }, null, 8 /* PROPS */, _hoisted_9),
                      (m.attachments.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(m.attachments, (f) => {
                              return (_openBlock(), _createElementBlock("a", {
                                key: f.name,
                                href: $setup.fileUrl(f),
                                class: "tx-chip"
                              }, [
                                _createVNode($setup["Icon"], {
                                  name: "paperclip",
                                  size: "14"
                                }),
                                _createTextVNode(_toDisplayString(f.file_name), 1 /* TEXT */)
                              ], 8 /* PROPS */, _hoisted_11))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */))
                  }), 128 /* KEYED_FRAGMENT */)),
                  ($setup.t.status_category !== 'Resolved')
                    ? (_openBlock(), _createElementBlock("form", {
                        key: 0,
                        class: "tx-card tx-composer",
                        onSubmit: _withModifiers($setup.send, ["prevent"])
                      }, [
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($setup.reply) = $event)),
                          rows: "4",
                          placeholder: $setup.state.t('tickets.reply'),
                          "aria-label": $setup.state.t('tickets.reply'),
                          maxlength: "20000"
                        }, null, 8 /* PROPS */, _hoisted_13), [
                          [_vModelText, $setup.reply]
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createVNode($setup["FilePicker"], {
                            modelValue: $setup.files,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($setup.files) = $event))
                          }, null, 8 /* PROPS */, ["modelValue"]),
                          _createElementVNode("button", {
                            class: "tx-btn tx-btn--primary",
                            disabled: $setup.busy || (!$setup.reply.trim() && !$setup.files.length)
                          }, _toDisplayString($setup.state.t("tickets.send_reply")), 9 /* TEXT, PROPS */, _hoisted_15)
                        ])
                      ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_12))
                    : _createCommentVNode("v-if", true),
                  ($setup.t.can_rate)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("h3", null, _toDisplayString($setup.state.t("tickets.rate")), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_17, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                            return _createElementVNode("button", {
                              key: n,
                              type: "button",
                              role: "radio",
                              "aria-checked": $setup.stars === n,
                              class: _normalizeClass({ on: n <= $setup.stars }),
                              onClick: $event => ($setup.stars = n)
                            }, [
                              _createVNode($setup["Icon"], {
                                name: "star",
                                size: "22"
                              })
                            ], 10 /* CLASS, PROPS */, _hoisted_18)
                          }), 64 /* STABLE_FRAGMENT */))
                        ]),
                        _withDirectives(_createElementVNode("textarea", {
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($setup.comment) = $event)),
                          rows: "2",
                          placeholder: $setup.state.t('tickets.rate_comment')
                        }, null, 8 /* PROPS */, _hoisted_19), [
                          [_vModelText, $setup.comment]
                        ]),
                        _createElementVNode("button", {
                          class: "tx-btn tx-btn--primary",
                          disabled: !$setup.stars || $setup.busy,
                          onClick: $setup.rate
                        }, _toDisplayString($setup.state.t("common.submit")), 9 /* TEXT, PROPS */, _hoisted_20)
                      ]))
                    : ($setup.t.rating)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                          _createVNode($setup["Icon"], {
                            name: "star",
                            size: "14"
                          }),
                          _createTextVNode(" " + _toDisplayString($setup.t.rating) + "/5 · " + _toDisplayString($setup.state.t("tickets.thanks")), 1 /* TEXT */)
                        ]))
                      : _createCommentVNode("v-if", true),
                  ($setup.t.can_reopen)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 3,
                        class: "tx-btn tx-btn--ghost",
                        disabled: $setup.busy,
                        onClick: $setup.reopen
                      }, _toDisplayString($setup.state.t("tickets.reopen")), 9 /* TEXT, PROPS */, _hoisted_22))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("aside", _hoisted_23, [
                  _createElementVNode("dl", _hoisted_24, [
                    ($setup.t.ticket_type)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("dt", null, _toDisplayString($setup.state.t("tickets.type")), 1 /* TEXT */),
                          _createElementVNode("dd", null, _toDisplayString($setup.t.ticket_type), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.t.priority)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("dt", null, _toDisplayString($setup.state.t("tickets.priority")), 1 /* TEXT */),
                          _createElementVNode("dd", null, _toDisplayString($setup.t.priority), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.t.team)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("dt", null, _toDisplayString($setup.state.t("tickets.team")), 1 /* TEXT */),
                          _createElementVNode("dd", null, _toDisplayString($setup.t.team), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.t.response_by)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                          _createElementVNode("dt", null, _toDisplayString($setup.state.t("tickets.sla_response")), 1 /* TEXT */),
                          _createElementVNode("dd", null, _toDisplayString($setup.fmtDate($setup.t.response_by, true)), 1 /* TEXT */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true),
                    ($setup.t.resolution_by)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                          _createElementVNode("dt", null, _toDisplayString($setup.state.t("tickets.sla_resolution")), 1 /* TEXT */),
                          _createElementVNode("dd", {
                            class: _normalizeClass({ 'tx-danger': $setup.t.overdue })
                          }, _toDisplayString($setup.fmtDate($setup.t.resolution_by, true)), 3 /* TEXT, CLASS */)
                        ], 64 /* STABLE_FRAGMENT */))
                      : _createCommentVNode("v-if", true)
                  ]),
                  ($setup.t.attachments.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        _createElementVNode("h3", null, _toDisplayString($setup.state.t("tickets.attachments")), 1 /* TEXT */),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.t.attachments, (f) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: f.name,
                            href: $setup.fileUrl(f),
                            class: "tx-filelink"
                          }, [
                            _createVNode($setup["Icon"], {
                              name: "download",
                              size: "14"
                            }),
                            _createTextVNode(_toDisplayString(f.file_name) + " ", 1 /* TEXT */),
                            _createElementVNode("small", null, _toDisplayString($setup.fmtSize(f.file_size)), 1 /* TEXT */)
                          ], 8 /* PROPS */, _hoisted_26))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ])
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["loading", "error"])
  ]))
}